import core from '@/store/modules/dots/active/core'
import card from '@/store/modules/dots/active/card'
import page from '@/store/modules/dots/active/page'
import system from '@/store/modules/dots/active/system'
import browser from '@/store/modules/dots/active/browser'

export default {
  namespaced: true,
  actions: {
    reset({ commit }) {
      commit('dots/active/core/reset', null, { root: true })
      commit('dots/active/card/reset', null, { root: true })
      commit('dots/active/system/reset', null, { root: true })
    }
  },
  modules: {
    core,
    card,
    page,
    system,
    browser
  }
}
